import React, { memo, SVGProps } from 'react'

export const Table = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.2435 3.144H6.75646C4.76638 3.144 3.14494 4.76448 3.14398 6.75552V17.2435C3.14398 19.2355 4.76446 20.856 6.75646 20.856H17.2435C19.2355 20.856 20.856 19.2355 20.856 17.2435V6.75648C20.856 4.76448 19.2355 3.144 17.2435 3.144ZM4.58398 10.008H11.2809V13.991H4.58398V10.008ZM12.7209 10.008H19.416V13.991H12.7209V10.008ZM19.416 6.75648V8.568H12.7209V4.58496H17.2435C18.4416 4.58496 19.416 5.5584 19.416 6.75648ZM6.75646 4.584H11.2809V8.56704H4.58398V6.75456C4.58398 5.55744 5.55934 4.584 6.75646 4.584ZM4.58398 17.2435V15.431H11.2809V19.415H6.75646C5.55838 19.415 4.58398 18.4416 4.58398 17.2435ZM17.2435 19.416H12.7209V15.432H19.416V17.2445C19.416 18.4426 18.4416 19.416 17.2435 19.416Z"
      fill="currentColor"
    />
  </svg>
))
